import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getVideosInApp = createAsyncThunk(
  "videosInApp/getVideosInApp",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const { data } = await axiosInstance.get(
        `/reels?page=${page}&size=${size}&query=${query}&adminOnly=true`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createVideoInApp = createAsyncThunk(
  "videosInApp/createVideoInApp",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/reels`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateVideoInApp = createAsyncThunk(
  "videosInApp/updateVideoInApp",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/reels/${args.id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteVideoInApp = createAsyncThunk(
  "videosInApp/deleteVideoInApp",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/reels/${args.id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const videosInAppSlice = createSlice({
  name: "videosInApp",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getVideosInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVideosInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getVideosInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })

      .addCase(createVideoInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createVideoInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createVideoInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateVideoInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateVideoInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        if (indexAt !== -1) {
          state.data[indexAt] = payload.data;
        }
        state.error = null;
      })
      .addCase(updateVideoInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteVideoInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteVideoInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteVideoInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default videosInAppSlice.reducer;
